"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
var react_native_1 = require("react-native");
var react_native_device_info_1 = __importDefault(require("react-native-device-info"));
require("react-native-get-random-values");
var statsig_react_1 = require("statsig-react");
var SDKVersion_1 = require("./SDKVersion");
/**
 * The StatsigProvider is the top level component from which all React SDK components derive
 * It initializes the SDK so child components can use FeatureGate and DynamicConfig values
 *
 * The provider accepts the same SDK initialization parameters as the statsig-js SDK.
 *
 * We recommend you place this at the entry point of your app and pass waitForInitialization = true
 * to ensure the SDK is initialized and all values are up to date prior to rendering anything.
 * @param props
 * @returns
 */
function StatsigProvider(_a) {
    var children = _a.children, sdkKey = _a.sdkKey, user = _a.user, options = _a.options, waitForCache = _a.waitForCache, waitForInitialization = _a.waitForInitialization, reactNativeUUID = _a.reactNativeUUID, mountKey = _a.mountKey, shutdownOnUnmount = _a.shutdownOnUnmount, initializingComponent = _a.initializingComponent, setUser = _a.setUser;
    return ((0, jsx_runtime_1.jsx)(statsig_react_1.StatsigProvider, __assign({ sdkKey: sdkKey, user: user, options: options, waitForCache: waitForCache, waitForInitialization: waitForInitialization, initializingComponent: initializingComponent, 
        // @ts-ignore
        _reactNativeDependencies: {
            SDKPackageInfo: {
                sdkType: 'react-native-client',
                sdkVersion: SDKVersion_1.version,
            },
            AsyncStorage: async_storage_1.default,
            AppState: react_native_1.AppState,
            NativeModules: react_native_1.NativeModules,
            Platform: react_native_1.Platform,
            RNDevice: react_native_device_info_1.default,
            Constants: null,
            ExpoDevice: null,
            ReactNativeUUID: reactNativeUUID !== null && reactNativeUUID !== void 0 ? reactNativeUUID : null,
        }, mountKey: mountKey, shutdownOnUnmount: shutdownOnUnmount, setUser: setUser }, { children: children }), void 0));
}
exports.default = StatsigProvider;
